import { Immutable } from "immer";
import React, { type JSX } from "react";
import { ChatLink } from "tsi-common-react/src/components/ChatLink/index";
import { FinancingPlan } from "tsi-common-react/src/models/financing";
import { usePageSetting } from "tsi-common-react/src/utils/settings";
import { usePageURL } from "tsi-common-react/src/utils/urls";

// TODO(i18n): Import translation functions from ttag for user-facing strings

import { BasketFinePrint } from "../BasketFinePrint";

import helpStyles from "../../../styles/composable/basket-summary-help.module.scss";

type IProps = Immutable<{
    plans: readonly FinancingPlan[];
    isMobile: boolean;
    cartID?: string;
}>;

export const BasketSidebarContent = (_props: IProps) => {
    const contactURL = usePageURL("contact_us_form");
    const homeURL = usePageURL("home");
    const supportPhoneNumberLink = usePageSetting(
        "support_website_phone_number_link",
    );
    const supportPhoneNumberDisplay = usePageSetting(
        "support_website_phone_number_display",
    );
    const phoneLink = (
        <a href={supportPhoneNumberLink || ""}>{supportPhoneNumberDisplay}</a>
    );
    let finePrint: JSX.Element | null = null;
    if (_props.isMobile) {
        finePrint = <BasketFinePrint plans={_props.plans} />;
    }

    return (
        <div>
            <div className={helpStyles.basketSummaryHelp}>
                {/* TODO(i18n): Wrap heading in t tagged template: <h3>{t`Questions?`}</h3> */}
                <h3>Questions?</h3>
                <div>
                    {/* TODO(i18n): Use jt to keep complete sentence together with interpolated components and variables */}
                    {/* Example: {jt`${chatLink} or Call ${phoneLink} and reference ${strongTag}`} */}
                    <p>
                        <ChatLink
                            className={helpStyles.basketSummaryHelpLink}
                            chatOfflineLink={contactURL || homeURL}
                        />
                        {" or "} <span>Call {phoneLink}</span>
                        <br />
                        {" and reference "}
                        <strong>{_props.cartID}</strong>
                    </p>
                </div>
            </div>
            {finePrint}
        </div>
    );
};
